import axios from 'axios';
import {backendHost} from '../../config';

export const getOperatorsById = (params) => {

    return axios.get(`${backendHost}/api/partners/admin/operators/${params.id}`);
};